/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:max-inline-declarations

import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { SplitSeparatorComponent } from './split-pane-separator.component';

@Component({
  selector: 'gh-vertical-split-separator',
  styles: [`
      :host {
          background-color: #fff;
          border-left: 1px solid #ddd;
          cursor: ew-resize;
          position: relative;
      }

      :host:hover {
          background-color: #fafafa;
      }

      .invisible-extension {
          position: absolute;
          height: 100%;
          width: 100%;
          min-width: 7px;
      }

      .handle {
          width: 100%;
          height: 35px;
          background-color: #eee;
          position: absolute;
          top: calc(50% - 17px);
      }
      .expand-accordion {
        cursor: pointer;
        position: absolute;
        top: 10px;
        width: 20px;
        height: 30px;
        z-index: 2;
        background-color: #cecece;
      }
      .expand-accordion .mat-icon{
        margin-top:3px;
        position: relative;
        left: -2px;
      }
      .expand {
        left:-20px;
        border-radius: 5px 0 0 5px;
      }
      .collapse {
        right: -20px;
        border-radius: 0 5px 5px 0;
      }
      
  `],
  template: `
    <!-- Used to extend the 'draggable' area in case the separator is too thin,
    so it's not too hard to drag. -->
    <div
      #invisibleExtension
      [hidden]="thickness >= 7"
      class="invisible-extension"></div>
    <div *ngIf="showExpand"
         class="expand expand-accordion"
         (click)="onExpandClick()"
         matTooltip="{{'lbl_expand' | translate}}">
      <mat-icon svgIcon="gh:chevron-left"></mat-icon>
    </div>
    <div class="collapse expand-accordion"
         (click)="onCollapseClick()"
         matTooltip="{{'lbl_collapse' | translate}}">
      <mat-icon svgIcon="gh:chevron-right"></mat-icon>
    </div>
    <div class="handle"></div>
  `,
  // tslint:disable-next-line:use-host-property-decorator
  host: {
    '[style.width.px]': 'thickness',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VerticalSplitSeparatorComponent extends SplitSeparatorComponent implements AfterViewInit {
  // tslint:disable-next-line:no-input-prefix
  @Input() canCollapsed: boolean;
  @Input() showExpand: boolean;
  @Output() collapseClick = new EventEmitter<void>();
  @Output() expandClick = new EventEmitter<void>();

  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    // tslint:disable-next-line:no-magic-numbers
    this.invisibleExtension.nativeElement.style.left = `${-(7 - this.thickness) / 2}px`;
  }

  onExpandClick(): void {
    this.expandClick.emit();
  }

  onCollapseClick(): void {
    this.collapseClick.emit();
  }

}
